"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const get_1 = __importDefault(require("lodash/get"));
const react_1 = require("react");
const ui_1 = require("react-science/ui");
const generateColor_1 = require("../../../data/utilities/generateColor");
function FormikColorPicker(props) {
    const { onColorChange = () => null, name } = props;
    const { values, setFieldValue } = (0, formik_1.useFormikContext)();
    function colorChangeHandler(color) {
        void setFieldValue(name, `${color.hex}${Math.round(color.rgb.a * 255).toString(16)}`, false);
        onColorChange(color);
    }
    return ((0, jsx_runtime_1.jsx)(ui_1.ColorPicker, { color: { hex: (0, get_1.default)(values, name, '#000') }, presetColors: generateColor_1.COLORS, onChangeComplete: colorChangeHandler, style: { boxShadow: 'none' } }));
}
exports.default = (0, react_1.memo)(FormikColorPicker);
